<template>
	<div v-if="renderFixed" class="ir-fixed-operate" :style="{ 'bottom': fixedBottom + 'px' }">
		<!-- 语言切换 -->
		<div
			v-if="showLanguageBtn"
			class="ir-fixed-operate-item ir-fixed-operate-image"
			@click="handleOperateItem('lang')"
		>
			<img :src="getLangImage" alt="" />
		</div>
		<!-- 预约调研 -->
		<div
			v-if="operateList.includes('survey') && findTargetModule('appointment')"
			class="ir-fixed-operate-item ir-fixed-operate-circle"
			@click="handleOperateItem('survey')"
		>
			<m-svg-icon name="survey1" class="ir-fixed-operate-icon" />
		</div>
		<!-- 投资者留言 -->
		<div
			v-if="operateList.includes('feedback') && findTargetModule('leave_word')"
			class="ir-fixed-operate-item ir-fixed-operate-circle"
			@click="handleOperateItem('feedback')"
		>
			<m-svg-icon name="feedback" class="ir-fixed-operate-icon" />
		</div>
		<!-- 消息订阅 -->
		<div
			v-if="operateList.includes('subscription') && findTargetModule('message_subscription')"
			class="ir-fixed-operate-item ir-fixed-operate-circle"
			@click="handleOperateItem('subscription')"
		>
			<m-svg-icon name="subscription" class="ir-fixed-operate-icon" />
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { changeLocaleLang, getLanguageByType, EN, ZH, ZH_HK } from '@/assets/js/i18n';
import { debounce, isApp } from '@/utils/api';
import I18_CN_ICON from '@/assets/images/irstore/i18-zh-cn.png';
import I18_HK_ICON from '@/assets/images/irstore/i18-zh-hk.png';
import I18_EN_ICON from '@/assets/images/irstore/i18-en.png';
import { useNavigation } from '@rebuild/hooks/useNavigation';
import { useCommonData } from '@rebuild/hooks/useCommonData';

export default {
	props: {
		delay: {
			type: Boolean,
			default: false
		},
		operateList: {
			type: Array,
			default: () => []
		},
		isCalendarModule: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			renderFixed: false,
			cacheEnterLanguage: this.$i18n.locale
		};
	},
	computed: {
		...mapGetters(['getIrTemplateData', 'getIrGlobalModules', 'getPageList']),
		getLangImage() {
			const map = {
				[ZH]: I18_CN_ICON,
				[ZH_HK]: I18_HK_ICON,
				[EN]: I18_EN_ICON
			};
			return map[this.$i18n.locale];
		},
		getLanguageList() {
			const enabledLang = this.getPageList
				.filter(v => v.languageSwitch)
				.map(v => getLanguageByType(v.languageType));
			const currentLang = this.cacheEnterLanguage;
			const composeLang = [...enabledLang, currentLang];
			return [...new Set(composeLang)];
		},
		showLanguageBtn() {
			// 按钮展示规则
			// 1. 进门渠道下不展示
			// 2. 仅支持一种语言时不展示
			const isJMChannel = isApp || this.isJMMiniProgram;
			if (isJMChannel) return false;
			if (this.getLanguageList.length <= 1) return false;

			const isLock = this.$route.query.lock;
			if (isLock) return false;
			if (this.hideLangByConfig) return false;

			return this.operateList.includes('lang');
		},
		hideLangByConfig() {
			const hostConfig = this.$store.getters.getHostConfig;
			return hostConfig.hideList && hostConfig.hideList.includes('lang');
		}
	},
	mounted() {},
	methods: {
		findTargetModule(moduleId) {
			return this.getIrGlobalModules.some(item => item.moduleId === moduleId);
		},
		init(bottom = 0) {
			this.fixedBottom = bottom;
			// 部分IOS机型出现 fixed 定位计算问题，延时处理
			if (!this.renderFixed) {
				if (this.delay) {
					setTimeout(() => {
						this.renderFixed = true;
					}, 600);
				} else {
					this.renderFixed = true;
				}
			}
		},
		handleOperateItem: debounce(function (val) {
			const { preview = false, lock = false } = this.$route.query;
			const stopPreview = preview && lock;
			if (stopPreview) {
				return;
			}

			switch (val) {
				case 'lang':
					this.handleLangChange();
					break;
				case 'survey':
					this.JumpToAppoint();
					break;
				case 'feedback':
					this.gotoFeedback();
					break;
				case 'subscription':
					this.gotoSubscription();
					break;

				default:
					break;
			}
		}),
		handleLangChange() {
			const languageList = this.getLanguageList;
			const findIdx = languageList.indexOf(this.$i18n.locale);
			// 按顺序递增索引 超出后归零
			const nextIdx = findIdx + 1 === languageList.length ? 0 : findIdx + 1;
			const pickLang = languageList[nextIdx];

			changeLocaleLang(pickLang);
		},
		JumpToPage(moduleId) {
			const tmpl = this.$route.params.tmpl;
			if (tmpl) {
				return this.goToModule(moduleId);
			}
			this.$navigateTo({
				name: `enterprise_ir_${moduleId}`,
				query: {
					storeId: this.$route.query.storeId
				}
			});
		},
		JumpToAppoint() {
			this.JumpToPage('appointment');
		},
		gotoFeedback() {
			this.JumpToPage('leave_word');
		},
		gotoSubscription() {
			this.JumpToPage('message_subscription');
		}
	},
	setup() {
		const { goToModule } = useNavigation();
		const { isJMMiniProgram } = useCommonData();

		return {
			goToModule,
			isJMMiniProgram
		};
	}
};
</script>

<style lang="less" scoped>
.ir-fixed-operate {
	position: fixed;
	z-index: 41;
	right: 0.14rem;

	.ir-fixed-operate-item {
		& + .ir-fixed-operate-item {
			margin-top: 0.12rem;
		}
	}

	.ir-fixed-operate-circle {
		width: 0.48rem;
		height: 0.48rem;
		background: #ffffff;
		box-shadow: 0 0.03rem 0.03rem rgba(0, 0, 0, 0.02);
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;

		.ir-fixed-operate-icon {
			font-size: 0.24rem;
			color: var(--ir-theme-color);
		}
	}

	.ir-fixed-operate-image > img {
		width: 0.48rem;
		height: 0.51rem;
	}
}
</style>
